/**
 * Layout component that wraps its children in a <main> element
 * with full viewport width and height, and no margin or padding.
 *
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children - The content to be rendered inside the layout.
 * @returns {JSX.Element} The rendered layout component.
 */
const Layout = ({ children }) => {
  return <main style={{ width: '100%', height: '100vh', margin: 0, padding: 0 }}>{children}</main>
}

// 📊 Exportar con Sentry Profiler
export { Layout }
